import { render, staticRenderFns } from "./FS_two_column_fullbleed.vue?vue&type=template&id=4b88c176&"
import script from "./FS_two_column_fullbleed.vue?vue&type=script&lang=js&"
export * from "./FS_two_column_fullbleed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports